<div class="empty-state">
  <div
    [innerHTML]="message()"
    class="empty-state-message"></div>
</div>
